import { Injectable } from '@angular/core';
import { Group } from '@wb/core/interfaces/group';
import { gql, Mutation } from 'apollo-angular';

export interface MutateGroupAccountResponse {
  code: String;
  success: Boolean;
  message: String;
}

export interface MutateGroupAccountVariables {
  accountUid: String;
  uid: String | null;
}

@Injectable({
  providedIn: 'root',
})
export class MutateGroupAccount extends Mutation<MutateGroupAccountResponse, MutateGroupAccountVariables> {
  document = gql(`
    mutation mutateGroupAccount($uid: ID, $accountUid: ID!) {
      mutateGroupAccount(uid: $uid, accountUid: $accountUid) {
        code
        success
        message
      }
    }
  `);
}

export interface CreateGroupResponse {
  createGroup: {
    code: string;
    success: string;
    message: string;
    group: Group;
  };
}

export interface CreateGroupVariables {
  input: CreateGroupInput;
}

export interface CreateGroupInput {
  name: string;
  defaultAccountUid?: string;
  accountUids?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class CreateGroupGQL extends Mutation<CreateGroupResponse, CreateGroupVariables> {
  document = gql(`
    mutation createGroup($input: ModelGroupInsertInput) {
      createGroup(input: $input) {
        code
        success
        message
        group {
          uid
          name
          default_account_id
        }
      }
    }
  `);
}

export interface DeleteGroupResponse {
  deleteGroup: {
    code: string;
    success: string;
    message: string;
  };
}

export interface DeleteGroupVariables {
  uid: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeleteGroupGQL extends Mutation<DeleteGroupResponse, DeleteGroupVariables> {
  document = gql(`
    mutation deleteGroup($uid: ID!) {
      deleteGroup(uid: $uid) {
        code
        success
        message
      }
    }
  `);
}

export interface GroupAccountMutationResponse {
  groupAccountMutation: {
    code: string;
    success: boolean;
    message: string;
  };
}

export interface GroupMutationVariables {
  uid: string;
  input: GroupUpdateInput;
}

export interface GroupUpdateInput {
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateGroupGQL extends Mutation<GroupAccountMutationResponse, GroupMutationVariables> {
  document = gql(`
    mutation updateGroup($uid: ID!, $input: ModelGroupUpdateInput!) {
      updateGroup(uid: $uid, input: $input) {
        code
        success
        message
      }
    }
  `);
}

export interface GroupAccountsMutationVariables {
  uid: string;
  input: GroupAccountInput[];
}

export interface GroupAccountInput {
  accountUid: string;
  action: 'add' | 'remove';
}

@Injectable({
  providedIn: 'root',
})
export class UpdateGroupAccountsGQL extends Mutation<GroupAccountMutationResponse, GroupAccountsMutationVariables> {
  document = gql(`
    mutation updateGroupAccounts($uid: ID!, $input: [ModelGroupUpdateAccountInput]) {
      updateGroupAccounts(uid: $uid, input: $input) {
        code
        success
        message
      }
    }
  `);
}
